import {iex} from '../Config/iex';

//Logic for fetching stock
export const stock = {
latestPrice : (ticker, callback) => {
    fetch(stock.latestPriceURL(ticker))
    .then((response)=> response.json())
    .then((data)=> callback(stock.formatPriceData(data)))
},
//URL for latest Price with the tocken ID and respective tickers
latestPriceURL : (ticker) =>{
   return `${iex.base_url}/stock/${ticker}/intraday-prices?chartLast=1&token=${iex.api_token}`
},
//Formatting the price data to a particular format
formatPriceData: (data) => {
    const stockData = data[data.length - 1]
    const formattedData ={}
    formattedData.price = stockData.close
    formattedData.date = stockData.date
    formattedData.time = stockData.label
    return formattedData
},
//Validating that the last trading date is not null which is important to calculate the dollar change and percentage changes
getYesterdaysClose:(ticker, lastTradingDate, callback)=>{
    if (lastTradingDate !== "" && lastTradingDate !== undefined){
       const url = stock.yesterdaysCloseURL(ticker,stock.formatDate(lastTradingDate))
       fetch(url)
       .then((response)=> response.json())
       .then((data)=> callback(stock.formatPriceData(data)))
   }
},

getLastTradingDate:()=>{
    var localDate = new Date();
    //Since NZ time is GMT+1200, setting an offset
    const userOffset = new Date().getTimezoneOffset()*60*1200;
    const utcDate = new Date(localDate.getTime() + userOffset);
    console.log(utcDate);
   const today = utcDate.toISOString().split('T')[0].replace(/-/g,'');
   // URL to get US trading dates and holidays
    const url = `${iex.base_url}/ref-data/us/dates/trade/last/1/${today}?token=${iex.api_token}`
    return fetch(url).then((res)=> res.json ());
},

yesterdaysCloseURL : (ticker, lastTradingDate) =>{
    //var lastTradingDate = stock.formatDate(date);
    return `${iex.base_url}/stock/${ticker}/intraday-prices?chartLast=1&exactDate=${lastTradingDate}&token=${iex.api_token}`
 },
 formatDate : (date) => {
    return new Date(date).toISOString().split('T')[0].replace(/-/g,'');
    }
}